import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';

export async function loadCommentEditable() {
    return await ArkLoader.extensionService.getExtension(componentConfig.name);
}

